var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallingPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.225 7.32098C18.5903 7.20373 18.0073 7.60878 17.8865 8.22836C17.7657 8.84793 18.172 9.45285 18.7895 9.5741C20.6485 9.93652 22.0839 11.3755 22.4477 13.2409V13.2422C22.5513 13.7792 23.024 14.1696 23.5685 14.1696C23.6415 14.1696 23.7145 14.1629 23.7889 14.1496C24.4063 14.0257 24.8127 13.4221 24.6918 12.8012C24.1487 10.0151 22.0042 7.86328 19.225 7.32098Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1424 2.67854C18.845 2.6359 18.5462 2.72384 18.3085 2.91305C18.0642 3.10492 17.9115 3.38206 17.8783 3.69251C17.8079 4.32008 18.2607 4.88769 18.8875 4.95831C23.2097 5.44064 26.5692 8.80767 27.0552 13.1434C27.1203 13.7243 27.6076 14.1627 28.1892 14.1627C28.233 14.1627 28.2755 14.16 28.3193 14.1547C28.6234 14.1214 28.8943 13.9708 29.0855 13.731C29.2754 13.4911 29.3617 13.1927 29.3272 12.8875C28.7217 7.47791 24.5349 3.27946 19.1424 2.67854Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7083 17.2965C20.0271 22.6138 21.2337 16.4623 24.6202 19.8464C27.8851 23.1103 29.7615 23.7643 25.625 27.8996C25.1069 28.316 21.8148 33.3257 10.2455 21.7596C-1.32529 10.192 3.68146 6.89659 4.09798 6.3786C8.2445 2.23179 8.88717 4.11918 12.152 7.38311C15.5385 10.7687 9.38956 11.9792 14.7083 17.2965Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingPrimary);
export default __webpack_public_path__ + "static/media/calling-primary.8a8a29fdc5e493530b80258282f7da06.svg";
export { ForwardRef as ReactComponent };